import React from "react"

const EmptyLayout = ({ children }) => {
  return <main>{children}</main>
}

export default EmptyLayout
